<template>
  <b-row v-if="period_context_loaded">
    <b-col class="p-0" style="flex: auto;">
      <b-row align-h="end" style="flex-wrap: wrap-reverse;" class="mb-1">
        <b-col class="px-0">
          <b-container fluid>
            <b-row class="align-period-filters-center">
              <b-col class="col-lg-6 col-12 mb-2 px-0 px-lg-2">
                <origin-filter>
                  <v-select
                    id="order-origin-selector"
                    slot="options"
                    class="origin-selector col pl-2"
                    :clearable="false"
                    v-model="orderOriginSelected"
                    :options="site_or_order_origin"
                    @input="updateOrderPeriodContext()"/>
                </origin-filter>
              </b-col>

              <b-col class="col-lg-6 col-12 mb-2 px-0 px-lg-2">
                <generic-filter>
                  <img slot="image" src="@/assets/period_icon.svg" alt="period_icon">
                  <v-select
                    id="period-selector"
                    slot="options"
                    class="origin-selector col pl-2"
                    :clearable="false"
                    :searchable="false"
                    v-model="periodSelected"
                    :options="periodOptions"
                    @input="updateOrderPeriodContext()"/>
                </generic-filter>
                <date-picker v-if="!isHidden" @date-selected="updateOrderPeriodContext"></date-picker>
              </b-col>
            </b-row>
          </b-container>
          
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import GenericFilter from '@/components/GenericFilter.vue'
import OriginFilter from '@/components/OriginFilter.vue'
import DatePicker from '@/components/DatePicker.vue'

export default {
  mounted() {
    this.$store.getters.url_order_current_period
    this.$store.getters.previous_date_querystring
    this.$store.getters.period_context_loaded

    this.orderOriginSelected.code = this.$store.getters.orderOriginSelectedCode
    this.orderOriginSelected.label = this.site_or_order_origin[this.orderOriginSelectedIndex]
      ? this.site_or_order_origin[this.orderOriginSelectedIndex].label
      : 'Todas as origens'

    this.periodSelected.code = this.$store.getters.orderPeriodSelectedCode
    this.periodSelected.label = this.periodTextArray[this.orderPeriodSelectedIndex]
  },
  components: {
    GenericFilter,
    OriginFilter,
    DatePicker
  },
  data: () => ({
    isHidden: true,
    orderOriginSelected: {
      code: null,
      label: null
    },
    periodSelected: {
      code: null,  // mudar tbm no store.js
      label: null
    }
  }),
  computed: {
    period_context_loaded() { return this.$store.getters.period_context_loaded },

    url_order_current_period() { return this.$store.getters.url_order_current_period },
    previous_date_querystring() { return this.$store.getters.previous_date_querystring },

    site_or_order_origin() { return this.$store.getters.site_or_order_origin },
    orderOriginSelectedIndex() { return this.$store.getters.orderOriginSelectedIndex },
    orderOriginText() { return this.site_or_order_origin[this.orderOriginSelectedIndex].label },

    periodTextArray() { return this.$store.getters.periodTextArray },
    orderPeriodSelectedIndex() { return this.$store.getters.orderPeriodSelectedIndex },
    periodText() { return this.periodTextArray[this.orderPeriodSelectedIndex] },
    periodOptions() {
      return [
        { code: 0, label: this.periodTextArray[0] },
        { code: 1, label: this.periodTextArray[1] },
        { code: 2, label: this.periodTextArray[2] },
        { code: 3, label: this.periodTextArray[3] },
        { code: 4, label: this.periodTextArray[4] },
        { code: 5, label: this.periodTextArray[5] },
        { code: 6, label: this.periodTextArray[6] },
        { code: 7, label: this.periodTextArray[7] },
        { code: 8, label: this.periodTextArray[8] },
      ]
    },
    selectedCurrentPeriod() {
      switch (this.orderPeriodSelectedIndex) {
        case 0:
          return "date_period=1"
        case 1:
          return "date_period=2"
        case 2:
          return "date_period=3"
        case 3:
          return "date_period=4"
        case 4:
          return "date_period=6"
        case 5:
          return "date_period=7"
        case 6:
          return "date_period=8"
        case 7:
          return "date_period=9"
        case 8:
          return "date_period=10"
        default:
          return "date_period=1"
      }
    },
  },
  methods: {
    updateOrderPeriodContext(date) {
      if (this.periodSelected.code === 8 && date === undefined) {
        this.periodSelected = 'Intervalo de Datas'
        this.isHidden = !this.isHidden;
        return
      } else if (this.periodSelected.code !== 8) {
        this.isHidden = true;
      }
      if (date !== undefined) {
        this.$store.commit('updatePeriodOriginSelectedIndex', {
          'period': 8,
          'origin': this.orderOriginSelected.code,
          'date_start': date.length === 2 ? date[0] : '',
          'date_end': date.length === 2 ? date[1] : date[0],
        })
         this.$store.commit('updateOrderPeriodContext', {
          'period': 8,
          'site_or_order_origin': this.orderOriginSelected.site_or_origin,
          'date_start': date.length === 2 ? date[0] : '',
          'date_end': date.length === 2 ? date[1] : date[0],
        })

        // Gambiarra pro Vue Select acionar o @input
        this.periodSelected = {}

        // Alteracao da Label para as Datas
        this.periodSelected.label = `${date.length === 2 ? this.dateFormat(date[0]) + ' ~ ' + this.dateFormat(date[1]) : this.dateFormat(date[0])}`

      } else {
        this.$store.commit('updatePeriodOriginSelectedIndex', {
          'period': this.periodSelected.code,
          'origin': this.orderOriginSelected.code,
        })
         this.$store.commit('updateOrderPeriodContext', {
        'period': this.periodSelected.code,
        'site_or_order_origin': this.orderOriginSelected.site_or_origin,
      })
      }

      this.$store.commit('updateOrderPeriodSelectedCode', this.periodSelected.code)
      this.$store.commit('updateOriginSelectedCode', this.orderOriginSelected.code)
    },
    dateFormat(date){
      return `${date.split('-').reverse().join('/')}`;
    }
  }
}
</script>

<style scoped lang="scss">
  .text-base {
    text-align: right;
  }

  @media only screen and (max-width: 576px) {
    .text-base {
      text-align: center !important;
    }
  }

  @media only screen and (max-width: 1000px) {
    div.align-period-filters-center {
      margin: 0 0 !important;
    }
  }

  .origin-selector {
    padding-right: 0;

    .vs__actions {
      position: absolute;
      right: 0px;
      top: 12px;
      padding: 0;

    }
    .vs__selected-options {
      max-height: 28px;

      .vs__selected {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .align-period-filters-center {
    margin: 0 -8px !important;
  }

  .origin-selector {
    padding-right: 0;

    .vs__actions {
      position: absolute;
      right: 0px;
      top: 12px;
      padding: 0;

    }
    .vs__selected-options {
      max-height: 28px;

      .vs__selected {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>